import {Component, OnInit} from '@angular/core';
import {ObjectBaseModeComponent} from '../../../../../../core/shared/object/mvs-object-base/object-base-mode.component';

@Component({
    selector: 'bm-bank-transaction-domain-base',
    template: '',
    standalone: false
})
export class BmBankTransactionDomainBaseComponent extends ObjectBaseModeComponent implements OnInit {

    navigationItems = [
        {
            label: 'Transaktionsdomaene',
            action: 'bankTransactionDomain',
            tooltip: 'Banktransaktionsdomaene Details',
            icon: 'fa-solid fa-network-wired',
            toggleable: false,
            default: true
        },
        {
            label: 'Transaktionsfamilien',
            action: 'bankTransactionFamily',
            tooltip: 'Banktransaktionsfamilien',
            icon: 'fa-solid fa-building-columns',
            toggleable: false,
            default: false
        },
        {
            label: 'Transaktionssubfamilien',
            action: 'bankTransactionSubFamily',
            tooltip: 'Banktransaktionssubfamilien',
            icon: 'fa-solid fa-diagram-project',
            toggleable: false,
            default: false
        }
    ];

    ngOnInit() {
        super.ngOnInit();
        this.initialized = true;
    }

}
